$(document).ready(function(){
  $('.collection_btn_show_more').click(function(evt){
    evt.preventDefault();
    var index = 1;
    var index_2 = 0;
    // $(this).closest('.colection_spec_outer').find('.ProductItem').removeClass('hidedCardOnLoad');
    $(this).closest('.colection_spec_outer').find('.ProductItem.hidedCardOnLoad').each(function(){
      if(index < 9){
        $(this).removeClass('hidedCardOnLoad');
        index ++;
      }
    });

    $(this).closest('.colection_spec_outer').find('.ProductItem.hidedCardOnLoad').each(function(){
      index_2 ++;
    });
    if (index_2 == 0){
      $(this).hide();
    }
    // $(this).hide();
  });
});